// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"442":"7e6bad33","847":"80586723"}[chunkId] + ".chunk.css";
};